import { BlockSimpleColor } from '@vtblife/block-kit-types';
export const BLOCK_SIMPLE_COLORS_MAP = {
    gray: 'hsl(230, 50%, 98%)',
    blue: 'hsl(238, 70%, 39%)',
    white: '#FFFFFF',
};
export const BLOCK_SIMPLE_COLORS_NEGATIVE_MAP = {
    [BlockSimpleColor.White]: BlockSimpleColor.Gray,
    [BlockSimpleColor.Blue]: BlockSimpleColor.White,
    [BlockSimpleColor.Gray]: BlockSimpleColor.White,
};
//# sourceMappingURL=block-simple-colors.js.map